// seeded randomizer
// https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
function mulberry32(a: number) {
  return function () {
    let t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
const hashCode: (str: string) => number = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
};

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
// + seeded randomizer
export const shuffleArray = <T>(seed: string | null, array: Array<T>) => {
  if (!seed) {
    return array;
  }

  const random = mulberry32(hashCode(seed));

  // fisher-yates shuffle
  let currentIndex = array.length;

  const arrayCopy = [...array];

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    const randomIndex = Math.floor(random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [arrayCopy[currentIndex], arrayCopy[randomIndex]] = [
      arrayCopy[randomIndex],
      arrayCopy[currentIndex],
    ];
  }

  return arrayCopy;
};
